import React, { useCallback } from "react";
import { Layout } from "antd";
import SearchBar from "./SearchBar";
import VehicleList from "./VehicleList";
import "./PlaybackSidebar.css";
import trans from "../../../utils";

const { Sider } = Layout;

const PlaybackSidebar = React.memo(({
  searchQuery,
  setSearchQuery,
  selectedGroup,
  setSelectedGroup,
  selectedStatus,
  setSelectedStatus,
  vehicles,
  groupedVehicles,
  groups,
  onChannelClick,
  isChannelActive,
  isLoading,
}) => {
  const handleGroupChange = useCallback((e) => {
    setSelectedGroup(e.target.value);
  }, [setSelectedGroup]);

  const handleStatusChange = useCallback((e) => {
    setSelectedStatus(e.target.value);
  }, [setSelectedStatus]);

  return (
    <Sider width={320} className="playback-sidebar" theme="dark">
      <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />

      <div className="sidebar-filters">
        <div className="filter-item">
          <label>{trans("status")}</label>
          <select
            value={selectedStatus}
            onChange={handleStatusChange}
            className="filter-select"
          >
            <option value="all">{trans("all status")}</option>
            <option value="online">Online</option>
            <option value="offline">Offline</option>
          </select>
        </div>

        <div className="filter-item">
          <label>{trans("groups")}</label>
          <select
            value={selectedGroup || "all"}
            onChange={handleGroupChange}
            className="filter-select"
          >
            <option value="all">{trans("all groups")}</option>
            <option value="ungrouped">{trans("ungrouped")}</option>
            {groups && Array.isArray(groups) && groups.length > 0
              ? groups.map((group) => (
                  <option key={group.id} value={String(group.id)}>
                    {group.name}
                  </option>
                ))
              : null}
          </select>
        </div>
      </div>

      <div className="sidebar-content">
        <VehicleList
          vehicles={vehicles}
          groupedVehicles={groupedVehicles}
          groups={groups}
          onChannelClick={onChannelClick}
          isChannelActive={isChannelActive}
          isLoading={isLoading}
        />
      </div>
    </Sider>
  );
});

export default PlaybackSidebar;
